import { render, staticRenderFns } from "./OvertimeDayLegend.vue?vue&type=template&id=513d751c&"
import script from "./OvertimeDayLegend.vue?vue&type=script&lang=js&"
export * from "./OvertimeDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('513d751c')) {
      api.createRecord('513d751c', component.options)
    } else {
      api.reload('513d751c', component.options)
    }
    module.hot.accept("./OvertimeDayLegend.vue?vue&type=template&id=513d751c&", function () {
      api.rerender('513d751c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/OvertimeDayLegend.vue"
export default component.exports